import { createSlice } from "@reduxjs/toolkit";

const selectedLabelSlice = createSlice({
  name: "selectedLabel",
  initialState: { subject: null, bookType: null },
  reducers: {
    setSelectedLabel: (state, action) => {
      state.subject = action.payload.subject;
      state.bookType = action.payload.bookType;
    },
    clearSelectedLabel: (state) => {
      state.subject = null;
      state.bookType = null;
    },
  },
});

export const { setSelectedLabel, clearSelectedLabel } = selectedLabelSlice.actions;
export default selectedLabelSlice.reducer;
